import styled, { css } from 'styled-components';

export const Wrapper = styled.article`
  ${({ theme, isChildrenSubscriptionList }) => css`
      font-family: ${theme.v2.font.family.primary};
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      padding: ${isChildrenSubscriptionList ? '24px 0' : '24px'};
      margin: 0;
      width: 100%;

      &:last-of-type {
        border-bottom: none;
      }

      @media (max-width: ${theme.v2.breakpoints.lg}){
        max-height: unset;
      }
    `}
`;

export const WrapperAddonListLabel = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.description};    
    color: ${theme.v2.colors.neutral.lowMedium};
    margin: 0 0 8px 0;
  `}
`;

export const WrapperContent = styled.div`
  ${({ theme }) => css`
      align-items: center;
      display: flex;
      justify-content: space-between;
      padding: 0;
      margin: 0;
      width: 100%;
      border-left: none;

      @media (max-width: ${theme.v2.breakpoints.lg}){
        max-height: unset;
        flex-direction: column;
        align-items: flex-start;
      }
    `}
`;


export const ProductName = styled.h1`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    margin-bottom: 0;
    margin-top: 0;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 300px;


    @media (max-width: ${theme.v2.breakpoints.lg}){
      max-width: 230px;
    }
  `}
`;

export const Domain = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    margin-bottom: 0;
    margin-top: 4px;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: ${theme.v2.breakpoints.lg}){
      max-width: 230px;
      font-size: ${theme.v2.font.sizes.xxxs};
    }
  `}
`;

export const StepperWrapper = styled.div`
  ${({ cancelled, theme }) => css`
    margin-top: ${cancelled ? '-35px' : '-26px'};

    > div {
      margin: 0px 30px 0px auto;
    }

    @media (max-width: ${theme.v2.breakpoints.lg}){
      margin-top: 0;
      margin-bottom: 40px;
    }
  `}
`;

export const Status = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
    text-wrap-mode: nowrap;
    white-space: nowrap;    

    @media (max-width: ${theme.v2.breakpoints.lg}){
      padding: 24px;
    }
  `}
`;

export const SubscriptionInfo = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex: 1;
    max-width: 400px;

    @media (max-width: ${theme.v2.breakpoints.lg}){
      min-width: unset;
    }
  `}
`;

export const Icon = styled.div`
  ${({ color }) => css`
    align-items: start;
    display: flex;
    height: 16px;
    width: 16px;

    svg {
      flex: initial;
      fill: ${color};
    }
  `}
`;

export const SubscriptionInfoDetails = styled.div`
  margin-left: 8px;
`;

export const MessageWrapper = styled.div`
  ${({ theme }) => css`
    margin-left: 34px;
    max-width: 465px;
    min-width: 312px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.lg}){
      margin: 0;
      max-width: 312px;
      min-width: unset;
    }

    p {
      margin: 0;
    }

    > div {
      padding: 0 24px
    }

    @media (max-width: ${theme.v2.breakpoints.lg}){
      > div {
      padding: 0px;

        > div {
          margin-left: 4px;
        }
      }
    }
  `}
`;

export const SubscriptionManage = styled.div`
  ${({ theme }) => css`
    display: contents;
    min-width: 176px;
    
    @media (max-width: ${theme.v2.breakpoints.lg}){
      align-self: flex-end;

      > button {
        margin-top: 24px;
        width: 100%;
      }
    }
  `}    
`;
